import { z } from 'zod';

export const objectiveIdSearchParam = z
  .preprocess(
    (v) => (v === '' || v === undefined ? undefined : Number(v)),
    z.number().int().positive().optional(),
  )
  .optional();
